import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';

/**
 *
 * @param center 中心点 数组
 * @param radius 半径
 * @param startAngle 起始角度
 * @param endAngle 终止角度
 * @param pointNum 圆弧上点的个数
 */
export function getPoints(center, radius, startAngle, endAngle, pointNum) {
  var sin;
  var cos;
  var x;
  var y;
  var angle;
  var points = [];
  // points.push(center);
  for (var i = 0; i <= pointNum; i++) {
    angle = startAngle + ((endAngle - startAngle) * i) / pointNum;
    sin = Math.sin((angle * Math.PI) / 180);
    cos = Math.cos((angle * Math.PI) / 180);
    y = center[0] + radius * cos;
    x = center[1] + radius * sin;
    points[i] = [y, x];
  }
  var point = points;
  // point.push(center);
  return point;
}

export function isSameLatLng(one, other) {
  if (isArray(one)) {
    if (one.length !== other.length) return false;
    return !find(one, (item, i) => !isSameLatLng(item, other[i]));
  } else {
    return one.lat === other.lat && one.lng === other.lng;
  }
}

// leaflet getLatLngs 可能会返回嵌套数组，在此进行处理
export function getLatLngs(latlngs) {
  if (isArray(latlngs)) {
    if (isArray(latlngs[0])) return latlngs[0];
    return latlngs;
  }
  return [];
}

export function isSameValue(arr) {
  if (isEmpty(arr)) return true;
  return arr.find((item, i) => {
    if (i > 0) {
      return item !== arr[i - 1];
    }
    return false;
  });
}
